export const handleEscape = (handleOnClose: { (key: string): void; (arg0: string): unknown }): (() => void) => {
  const checkIfEscape = (e: { keyCode: number }) => e.keyCode === 27 && handleOnClose('');
  window.addEventListener('keydown', checkIfEscape);
  return () => window.removeEventListener('keydown', checkIfEscape);
};
